/* eslint-disable eqeqeq */
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
import http from '../../../Utils/http';
import { getAppOriginAndTimezone } from '../../../Utils/getAppOrigin';

const Approval = {
  name: 'approval',
  state: {
    loading: false,
    error: null,
    reqError: null,
    data: [],
    totalCount: 0,
    currentReq: null,
    tableHeader: [
      'Organization',
      'Campaign Name',
      'Start Date',
      'End Date',
      'Status',
    ],
    rpp: 10,
  },
  reducers: {
    approvalRequested(state) {
      return {
        ...state,
        loading: true,
      };
    },

    approvalRecived(state, payload) {
      payload.data = payload.data.map((item) => {
        return item;
      });
      return { ...state, loading: false, ...payload };
    },
    approvalDetailsRecived(state, payload) {
      return { ...state, loading: false, ...payload };
    },
    approvalFailed(state, payload) {
      return {
        ...state,
        loading: false,
        ...payload,
      };
    },
    clearRequestInfo(state) {
      return { ...state, currentReq: null, reqError: null };
    },
  },
  effects: (dispatch) => ({
    async ApproveOrReject(data, state) {
      try {
        const id = JSON.parse(localStorage.getItem('userInfo')).org_id;
        const user = JSON.parse(localStorage.getItem('userInfo'));
        let url = `savvy/approval-flow/${data?.req_id}?user_id=${user?.id}&org=${user?.org_id}`;

        const onBehalf = JSON.parse(localStorage.getItem('onBehalfName'));
        const { origin, timezone } = getAppOriginAndTimezone();
        const newData = {
          ...data,
          onBehalf,
          origin,
          timezone,
        };
        await http.put(url, newData, id);

        this.approvalRecived();
      } catch (err) {
        this.approvalFailed({ reqError: err?.message });
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
    async Reject(data) {
      try {
      } catch (err) { }
    },
    async getAll({
      page,
      size,
      search,
      sorted_by,
      sort,
      isInactive,
      start_date,
      end_date,
      granularity,
    }, state) {
      try {
        let org_id = state?.user?.data?.org_id;
        if (!org_id) {
          const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
          org_id = userInfo?.org_id;
        }

        if (!org_id) {
          this.approvalFailed({ error: 'Organization ID not found' });
          return;
        }

        this.approvalRequested();

        let url = `savvy/approval-flow/${org_id}?page=${page || 1}&size=${size || 10}&active=${isInactive || false}`;

        if (search) {
          url = url + `&search=${encodeURIComponent(search)}`;
        }
        if (sorted_by) {
          url = url + `&sorted_by=${encodeURIComponent(sorted_by)}`;
        }
        if (sort) {
          url = url + `&sort=${encodeURIComponent(sort)}`;
        }
        if (start_date) {
          url = url + `&start_date=${encodeURIComponent(start_date)}`;
        }
        if (end_date) {
          url = url + `&end_date=${encodeURIComponent(end_date)}`;
        }
        if (granularity) {
          url = url + `&granularity=${encodeURIComponent(granularity)}`;
        }
        const response = await http.get(url);

        this.approvalRecived({
          data: response.data.data.rows,
          totalCount: response.data.data.count,
        });
      } catch (err) {
        this.approvalFailed({ error: err?.message });
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
    async getRequestInfo(request_id, state) {
      try {
        if (!request_id) {
          return;
        }

        const isInitialLoad = !state?.approval?.currentReq;
        if (isInitialLoad) {
          this.approvalRequested();
        }
        
        const user = JSON.parse(localStorage.getItem('userInfo'));
        
        if (!user?.id || !user?.org_id) {
          this.approvalFailed({ reqError: 'User information not found' });
          return;
        }

        let url = `savvy/approval-flow/details/${request_id}?user_id=${user.id}&org=${user.org_id}`;

        const response = await http.get(url);

        this.approvalDetailsRecived({
          currentReq: response.data?.data,
        });
      } catch (err) {
        this.approvalFailed({ reqError: err?.message });
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default Approval;
